
	import {
		Component,
		Prop,
		Vue,
		Watch
	} from "vue-property-decorator";
	import UploadImg from '@/components/upload-img.vue';
	import previewImg from '@/components/previewImg.vue';
	import {
		imgHost
	} from '@/utils/config'
	import draggable from 'vuedraggable'
	
	import {specImgSelectLeveLog} from '@/api/supplier';

	@Component({
		name: 'sku-list',
		components: {
			UploadImg,
			draggable,
			previewImg
		}
	})
	export default class SkuList extends Vue {
		@Prop({}) private list!: any;
		@Prop({}) private token!: any;
		@Prop({}) private id: any;
		@Prop({default: false}) private IsIncludedSubmitOrderInfo!: boolean;
		@Prop({default: false}) private IsShareStock!: boolean;
		@Prop({default: false}) private changeDrag!: boolean;
		@Prop({default: ''}) private MainSpecSelectLeve!: any;
		@Prop({
			default: false
		}) private disabled!: any;
		private imgUrl = imgHost;
		private checked = true
		private inputVal: any = '';
		private isIncludePicIndex: any = -1; // 是否包含图片的sku index
		private newChild = ''
		private classindex = null
		private specindex = null
		private changeinputValue = ''
		private Included = false
		private Shared = false
		private currentUrl = ''
		private showPreview = false
		@Watch('IsIncludedSubmitOrderInfo')
		private getIsIncludedSubmitOrderInfo(val:boolean){
			this.Included = this.IsIncludedSubmitOrderInfo
		}
		@Watch('IsShareStock')
		private getIsShareStock(val:boolean){
			this.Shared = this.IsShareStock
		}
		@Watch('list')
		private onChangeList(val: any) {
			console.log(val)
			if (val && val.length) {
				val.map((item: any, index: number) => {
					item.sku_info && item.sku_info.map((child: any) => {
						if (child.pic_url) {
							this.isIncludePicIndex = index;
							return
						}
					})

				})
			}

			this.$emit('change', {
				list: this.list,
				picIndex: this.isIncludePicIndex
			})
		}

		private showDeleteBtn(record, index){
			if (this.disabled) return false;
			if (index === this.list.length-1 && record.sku_name == '现货/预售') return false;
			return true;
		}
		private skuNameDisabled(record, index){
			if (this.disabled) return true;
			if (index === this.list.length-1 && record.sku_name == '现货/预售') return true;
			return false;
		}

		private downFile(name,type){
			window.open(`https://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/Files/${encodeURI(name)}.${type}`)
		}
		private lookimg(img){
			this.showPreview = true
			this.currentUrl = `https://cdn2024.routuan.com/routuan/image/${img}.png`
		}

		private mainlevechange(e,index){
			this.$emit('changeMainSpecSelectLeve', e?index:'')
			// console.log(e,index,this.MainSpecSelectLeve)
		}

		private changesort(i){
			let num = JSON.parse(JSON.stringify(this.list[i].Sort))
			if(!num){
				this.$message.error('请完善规格的序号值')
				this.list[i].Sort = ''
				return 
			}
			// else if(num > this.list.length){
			// 	this.$message.error('规格排序不能大于'+this.list.length)
			// 	return 
			// }
			this.$emit('change', {
				list: this.list,
			})
		}
		private dragskuend(){
			this.$emit('change', {
				list: this.list,
			})
		}

		private blurCount(i,ci){
			// console.log(this.list[i].sku_info[ci].Count)
			let num = JSON.parse(JSON.stringify(this.list[i].sku_info[ci].Count))
			if(num < 1 || num > 9999 || num != parseInt(num)){
				this.$message.error('只能输入正整数，最大输入值：9999')
				this.list[i].sku_info[ci].Count = ''
				return 
			}
			this.$emit('change', {
				list: this.list,
			})
		}

		private changeShared(val){
			this.$emit('changeShared',val)
		}

		private changeswich(val){
			this.$emit('change', {
				list: this.list,
			})
		}

		private changeIsIncludedSubmitOrderInfo(val){
			this.$emit('changeIsIncludedSubmitOrderInfo',val)
		}

		private handleInputConfirm() {
			if (!this.changeinputValue) {
				this.$message.error('请输入型号名')
				return
			}
			let newclassindex = JSON.parse(JSON.stringify(this.classindex))
			let newspecindex = JSON.parse(JSON.stringify(this.specindex))
			let oldvalue = this.list[newclassindex].sku_info[newspecindex].sku_value
			this.list[newclassindex].sku_info[newspecindex].sku_value = this.changeinputValue
			// console.log(oldvalue)
			// console.log(this.list,222)
			this.$emit('change', {
				list: this.list,
				// index: index,
				// picIndex: this.isIncludePicIndex,
				changetype:1,//1修改名称
				oldvalue:oldvalue,
				newvalue:this.changeinputValue,
				newclassindex:newclassindex,
				picIndex: this.isIncludePicIndex
			})
			this.classindex = null
			this.specindex = null
		}

		private showinput(v, m, n) {
			this.changeinputValue = v.sku_value
			this.classindex = m
			this.specindex = n
			this.$nextTick(() => {
				// console.log(this.$refs.changeinput[0])
				this.$refs.changeinput[0].$refs.input.focus()
			})

		}

		private handleChange(index: number) {
			if (this.isIncludePicIndex !== -1) {
				this.list[this.isIncludePicIndex].sku_info.map((item: any) => {
					item.pic_url = ''
				})
			}
			if (index === this.isIncludePicIndex) {
				this.isIncludePicIndex = -1
			} else {
				this.isIncludePicIndex = index;
			}

			this.$emit('change', {
				list: this.list,
				index: index,
				picIndex: this.isIncludePicIndex
			})
			
			if (this.id){
				this.setPicLog();
			}
			
		}
		
		private async setPicLog(){
			try {
			
				let params:any = {
					ProductId: this.id,
					SpecImgSelectLeve: this.isIncludePicIndex
				}
			
				const res: any = await specImgSelectLeveLog(params);
			} catch (e) {
			}
		}

		// 上传成功回调 
		private uploadSuc(pics: any, index: number, cindex: number) {
			this.list[index].sku_info[cindex].pic_url = pics[0];
			this.$emit('change', {
				list: this.list,
				index: index,
				picIndex: this.isIncludePicIndex
			})
		}

		// 添加子型号
		private appendChild(index: number,item:any) {
			if (!this.list[index].sku_name) {
				this.$message('请输入类型名');
				return;
			}
			if (!this.newChild) {
				this.$message('请输入型号名');
				return
			}
			// console.log(this.newChild,item.sku_info,123)
			if(item.sku_info.find(v=>v.sku_value==this.newChild)){
				this.$message.error('规格值重复，请重新输入');
				return
			}
			this.list[index].visible = false
			this.list[index].sku_info.push({
				sku_value: this.newChild,
				pic_url: '',
				sku_id: '',
				sku_ids: [],
				isNew: true,
				classKey:Math.random(),
				Count:'',
				IsCanSubmitOrder:true,
			})
			this.newChild = ''
			this.$emit('change', {
				list: this.list,
				index: index,
				type: 'add',
				picIndex: this.isIncludePicIndex
			})
		}

		// 删除item
		private delItem(index: number) {
			if (this.isIncludePicIndex > index) {
				this.isIncludePicIndex -= 1
			}
			if (this.MainSpecSelectLeve > (index+1)) {
				
				this.$emit('changeMainSpecSelectLeve',this.MainSpecSelectLeve - 1)
			}
			//如果当前规格包含图片 
			this.isIncludePicIndex = this.isIncludePicIndex == index ? -1 : this.isIncludePicIndex;
			// console.log(this.isIncludePicIndex,index)
			if(index+1==this.MainSpecSelectLeve){
				this.$emit('changeMainSpecSelectLeve', '')
			}
			this.list.map(item=>{
				item.sku_info.map(obj=>{
					obj.sku_ids = [];
					obj.sku_id = 0;
					return obj;
				})
				return item;
			})
			
			this.$emit('delete', {
				index: index,
				list: this.list,
				picIndex: this.isIncludePicIndex
			})
			// console.log(this.MainSpecSelectLeve)
		}

		// 删除型号
		private deleteChild(index: number, cindex: number) {
			let ids = this.list[index].sku_info[cindex].sku_ids;

			this.list.map(item=>{
				item.sku_info.map(obj=>{
					let list = [];
					obj.sku_ids.map(o=>{
						if (ids.indexOf(o)<0){
							list.push(o)
						}
					})
					obj.sku_ids = list;
					return obj;
				})
				return item;
			})
			
			this.list[index].sku_info.splice(cindex, 1);
			this.$emit('change', {
				list: this.list,
				type: 'delete',
				picIndex: this.isIncludePicIndex
			})
		}
	}
